import type { AgentCreatePrefill, DemoCreatePrefill, NumberAttachPrefill } from "@/symphony/contract";

export interface AgentCreateRequest extends AgentCreatePrefill {
  id: string;
}

export interface DemoCreateRequest extends DemoCreatePrefill {
  id: string;
}

export interface NumberAttachRequest extends NumberAttachPrefill {
  id: string;
}

type Listener = () => void;

const listeners = new Set<Listener>();

let agentCreate: AgentCreateRequest | null = null;
let demoCreate: DemoCreateRequest | null = null;
let numberAttach: NumberAttachRequest | null = null;

function emit() {
  for (const listener of listeners) listener();
}

function makeId(prefix: string): string {
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}

export function subscribeSymphonyPending(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function peekAgentCreate(): AgentCreateRequest | null {
  return agentCreate;
}

export function peekDemoCreate(): DemoCreateRequest | null {
  return demoCreate;
}

export function peekNumberAttach(): NumberAttachRequest | null {
  return numberAttach;
}

export function publishAgentCreate(prefill: AgentCreatePrefill): AgentCreateRequest {
  agentCreate = { ...prefill, id: makeId("agent") };
  emit();
  return agentCreate;
}

export function publishDemoCreate(prefill: DemoCreatePrefill): DemoCreateRequest {
  demoCreate = { ...prefill, id: makeId("demo") };
  emit();
  return demoCreate;
}

export function publishNumberAttach(prefill: NumberAttachPrefill): NumberAttachRequest {
  numberAttach = { ...prefill, id: makeId("number") };
  emit();
  return numberAttach;
}

export function clearAgentCreate(): void {
  if (!agentCreate) return;
  agentCreate = null;
  emit();
}

export function clearDemoCreate(): void {
  if (!demoCreate) return;
  demoCreate = null;
  emit();
}

export function clearNumberAttach(): void {
  if (!numberAttach) return;
  numberAttach = null;
  emit();
}

export function resetSymphonyPending(): void {
  agentCreate = null;
  demoCreate = null;
  numberAttach = null;
  emit();
}
